__turbopack_context__.v({
  "selectedCard": "xSG7ta_selectedCard",
  "selectedList": "xSG7ta_selectedList",
  "teamLeadLabel": "xSG7ta_teamLeadLabel",
  "teamLeadToggle": "xSG7ta_teamLeadToggle",
});
